var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordion",class:{ 'is-open': _vm.expand }},[_c('div',{staticClass:"accordion-ttl",on:{"click":function($event){return _vm.toggle()}}},[_vm._t("title")],2),_c('div',{staticClass:"accordion-body"},[_vm._t("body")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }